import React, { useState } from "react";

const Calendar = () => {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthName = currentDate.toLocaleString("default", { month: "long" });

  const days = [];
  for (let i = 0; i < firstDay; i++) days.push(null);
  for (let d = 1; d <= daysInMonth; d++) days.push(d);

  const handlePrevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  return (
    <div className="bg-white rounded-lg p-4 shadow-md hover:scale-[1.02] transition-all duration-300">
      <div className="flex justify-between items-center mb-2">
        <button
          onClick={handlePrevMonth}
          className="text-gray-600 hover:text-blue-600 transition"
        >
          ◀
        </button>
        <h2 className="text-center font-semibold text-lg text-gray-800">
          {monthName} {year}
        </h2>
        <button
          onClick={handleNextMonth}
          className="text-gray-600 hover:text-blue-600 transition"
        >
          ▶
        </button>
      </div>

      <div className="grid grid-cols-7 gap-1 text-sm text-gray-700 text-center font-medium">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day}>{day}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1 text-sm text-center mt-1">
        {days.map((day, index) => {
          const isToday =
            day === today.getDate() &&
            month === today.getMonth() &&
            year === today.getFullYear();

          return (
            <div
              key={index}
              className={`h-8 flex items-center justify-center rounded-full cursor-pointer transition ${
                isToday
                  ? "bg-blue-500 text-white font-bold"
                  : day
                  ? "hover:bg-blue-100"
                  : ""
              }`}
            >
              {day || ""}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
